import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/sonner';
import { cn } from '../../lib/utils';

export const MainLayout = () => {
    const { isAuthenticated, loading } = useAuth();
    const { isDark } = useTheme();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    if (loading) {
        return (
            <div className={cn(
                "min-h-screen flex items-center justify-center",
                isDark ? "bg-[#050505]" : "bg-gray-50"
            )}>
                <div className="flex flex-col items-center gap-4">
                    <div className="w-12 h-12 border-4 border-cyan-500/30 border-t-cyan-500 rounded-full animate-spin" />
                    <p className={isDark ? "text-gray-400" : "text-gray-600"}>Loading...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className={cn(
            "min-h-screen transition-colors duration-200",
            isDark ? "bg-[#050505]" : "bg-[#f8fafc]"
        )}>
            <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
            
            <main className="lg:ml-64 min-h-screen p-4 sm:p-6 lg:p-8 pt-16 lg:pt-8">
                <div className="max-w-7xl mx-auto">
                    <Outlet />
                </div>
            </main>

            <Toaster 
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: isDark ? 'hsl(0 0% 4%)' : 'white',
                        border: isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)',
                        color: isDark ? 'white' : '#111',
                    },
                }}
            />
        </div>
    );
};
